import React from 'react';
import useFeatureFlags from 'hooks/useFeatureFlags';

const VersionOneSecondaryRoleOptions = () => (
  <li>
    {t('settings.tab.roles.edit.learning_permission_label_skills_completion')}
  </li>
);

const VersionTwoSecondaryRoleOptions = () => (
  <li>
    {t(
      'settings.tab.roles.edit.learning_permission_label_skills_completion_v2',
    )}
  </li>
);

const LearningRole = () => {
  const hasSkillsEnabled = useFeatureFlags([
    'readiness-enable-skills-2-0',
    'skills',
  ]);

  return hasSkillsEnabled ? (
    <VersionTwoSecondaryRoleOptions />
  ) : (
    <VersionOneSecondaryRoleOptions />
  );
};

export default LearningRole;
